import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Button } from '@mui/material';

function Page5() {
    // return <h1>This is Page 5</h1>;
    // state to hold posts fetched from server; intialized to an empty array
    const [posts, setPosts] = useState([]);

    // run once component loads
    useEffect(() => {
        // send GET request to backend to retrieve posts from followed users
        axios.get('/user/following/posts')
            .then(res => setPosts(res.data)) // on success, update "posts" with fetched data
            .catch(err => console.error("Error loading following posts", err));
    }, []);

    // fxn called when user clicks upvote button
    // postId: MongoDB _id of the post being unvoted
    // sends POST /post/:id/upvote to server
    // receives { upvotes, voted } in response
    // patches React state so UI shows the new count and color
    const toggleVote = async (postId) => {
        try {
             // hit backend endpoint that toggles a vote
             const res = await axios.post(`/post/${postId}/upvote`);

             // update <posts> in react state so ui rerenders
             // setPosts(prev => ...) receives the previous array of posts and must return a new array
             // prev.map( p => { ... } ) 
                // iterate through every post p in old array
                // if p is the one user just voted on, return a new object with the fresh upvote info from server
                // otherwise, return p unchanged
            setPosts((prev) =>
                prev.map((p) =>
                    p._id === postId
                        ? {
                            ...p, // copy exisiting post fields
                            upvotes: res.data.upvotes, // updated count
                            voted:   res.data.voted // true or false that user voted
                        }
                        : p // all other posts unchanged
                )
            );

        } catch(err) {
            console.error("Vote error", err);
        }
    };

    // render component UI
    return (
        <Box p={4}>
            {/* following page title */}
            <Typography variant="h4">Following Feed</Typography>

            {/* If there are no posts, show a message */}
            {posts.length === 0 ? (
                <Typography>No posts from followed users.</Typography>
            ) : (
            // if there are posts, loop through each and render it
            posts.map((post, idx) => (
                <Box
                    key={idx}            // key is needed by React for list rendering
                    p={2}                // padding inside each post box
                    my={2}               // margin above and below each post box
                    border="1px solid #ccc"  // light border around each post
                    borderRadius="8px"       // rounded corners
                >
                    {/* show username of the post author */}
                    <Typography variant="subtitle1" fontWeight="bold">
                        @{post.author?.username || 'Unknown'}
                    </Typography>

                    {/* show post content */}
                    <Typography>{post.content}</Typography>

                    {/* show formatted creation date below content */}
                    <Typography variant="caption" display="block">
                        {new Date(post.created_at).toLocaleString()}
                    </Typography>

                    {/* Upvote button */}
                    {/*
                    <Box mt={2} display="flex" gap={2}>
                        <Button variant="outlined" size="small">Upvote</Button>
                    </Box>
                    */}
                    <Box mt={2} display="flex" alignItems="center" gap={1}>
                        <Button
                            size="small"
                            variant={post.voted ? "contained" : "outlined"}
                            onClick={() => toggleVote(post._id)}
                        >
                            ▲ {post.voted ? "Un‑vote" : "Up‑vote"}
                        </Button>
                        <Typography variant="body2">{post.upvotes} up‑votes</Typography>
                    </Box>
                </Box>
            ))
        )}
        </Box>
    );
}

export default Page5;